import React from 'react'
import { Link } from "react-router-dom";


const Blog = () => {
    return (
        <>
            <section className="page_breadcrumb" style={{ background: 'url(assets/img/breadcrumb_bg.webp)' }}>
                <div className="breadcrumb_overlay">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="breadcrumb_text">
                                    <h1>Our Blog</h1>
                                    <ul className="d-flex flex-wrap">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/">Our Blog</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="blog_page pt_95 xs_pt_75">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row">
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Career Guidance.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                        <div className="single_blog_text">
                                            <Link className="category" to="/blog-details">Explore More</Link>
                                            <Link className="title" to="/blog-details">Career Guidance: Skills That Employers Look for in 2026</Link>
                                            <p>The job market is constantly evolving. Learn the essential skills employers value and how career guidance can improve your chances of landing your ideal job.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Natural Wellness.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                        <div className="single_blog_text">
                                            <Link className="category" to="/blog-details">Explore More</Link>
                                            <Link className="title" to="/blog-details">Natural Wellness: Benefits of Ayurvedic Health Products</Link>
                                            <p>Natural wellness products support overall health using time-tested Ayurvedic ingredients. Discover how herbal supplements can help improve immunity, digestion, and everyday well-being.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Business Solutions_1.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                        <div className="single_blog_text">
                                            <Link className="category" to="/blog-details">Explore More</Link>
                                            
                                            <Link className="title" to="/blog-details">Why Businesses Need Integrated Business Solutions in 2026</Link>
                                            <p>Running a business involves managing multiple services—from company registration and GST compliance to website development, manpower, and facility management. Choosing a single service provider helps improve efficiency, reduce costs, and simplify business operations.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Professional Facility.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                        <div className="single_blog_text">
                                            <Link className="category" to="/blog-details">Explore More</Link>
                                            
                                            <Link className="title" to="/blog-details">Top Benefits of Professional Facility Management Services</Link>
                                            <p>A well-managed facility improves workplace productivity, employee satisfaction, and operational efficiency. Professional facility management ensures your business remains clean, secure, and fully operational.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Business Website.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                        <div className="single_blog_text">
                                            <Link className="category" to="/blog-details">Explore More</Link>
                                            
                                            <Link className="title" to="/blog-details">Why Every Business Needs a Professional Website</Link>
                                            <p>Your website is your digital storefront. A professionally designed website builds trust, improves visibility on search engines, and helps convert visitors into customers.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Income Tax.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                        <div className="single_blog_text">
                                            <Link className="category" to="/blog-details">Explore More</Link>
                                            
                                            <Link className="title" to="/blog-details">GST & Income Tax Filing: Avoid Common Mistakes</Link>
                                            <p>Timely GST and Income Tax filing helps businesses stay compliant and avoid penalties. Learn the common mistakes business owners make and how professional tax services can save time and money.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Blog